<!-- Planned dates -->
<div class="p-4 bg-third-level rounded-lg">
  <div class="space-y-1 text-sm">
    <div class="flex justify-between">
      <span>{{ 'project.steps.invitationList.plannedShippingDate' | transloco }}:</span>
      <span class="font-medium flex items-center gap-2" data-testid="planned-shipping-date">
        @if (config().timeFrame; as timeFrame) {
          {{ timeFrame.startDate | appDate }}
        } @else {
          -
        }
        <app-directus-tooltip
          [tooltipKey]="config().tooltipKeys.plannedShippingDate"
          tooltipStyleClass="tooltip-bg-second-level"
        >
        </app-directus-tooltip>
      </span>
    </div>
    <div class="flex justify-between">
      <span>{{ 'project.steps.invitationList.plannedSubmissionDate' | transloco }}:</span>
      <span class="font-medium flex items-center gap-2" data-testid="planned-submission-date">
        @if (config().timeFrame; as timeFrame) {
          {{ timeFrame.estimatedEndDate | appDate }}
        } @else {
          -
        }
        <app-directus-tooltip
          [tooltipKey]="config().tooltipKeys.plannedSubmissionDate"
          tooltipStyleClass="tooltip-bg-second-level"
        >
        </app-directus-tooltip>
      </span>
    </div>
  </div>
</div>
